import { maskPhone } from "@/common/helpers/mask.helpers";
import { InfoTable } from "../../../../common/components/ui/table/InfoTable";
import { useIndicatorDashboardContext } from "../indicator-dashboard/useIndicatorDashboardContext";

export function InfoIndicatorBlock() {
  const { indicator } = useIndicatorDashboardContext();

  return (
    <InfoTable
      title="Informações do Indicador"
      data={[
        { label: "Nome", value: indicator.name },
        { label: "WhatsApp", value: maskPhone(indicator.whatsapp) },
      ]}
    />
  );

  /**TO DO:
   * VERIFICAR A POSSIBLIDADE DE APARECER O NOME DO MOTORISTA SE O STATUS FOR: lOCADA
   */
}
